/**
 * Thin axios client for svc-audit-log-api (`POST /v1/logs`).
 *
 * The admin portal calls it with its internal-auth token: the target organization is selected
 * via `x-epilot-org-id`, and `visibility: 'all'` (internal callers only) also returns the rows
 * written by epilot staff through the admin portal.
 */
import axios, { AxiosInstance } from 'axios'

import { config } from '../configs/api.config'

import { configureClient } from './api-utils'

let client: AxiosInstance | undefined

export const getAuditLogClient = (): AxiosInstance => {
  if (!client) {
    client = axios.create({ baseURL: config.AUDIT_LOG })
    configureClient(client, { baseURL: config.AUDIT_LOG })
  }

  return client
}
